import React from 'react';
import { defineBlock, smartProps, useInspectorControl } from '@smartfire/js-block-engine';

import Button from '../../../../button/block';

import style from './block.module.scss';

const Inspector = React.lazy(() => import('./Inspector.js'));

const Submit = ({ text }) => {
    useInspectorControl(Inspector);

    return (
        <Button
            text={text}
            inspector={false}
            aspect={'contained'}
            color={style.darkBlue}
            colorHover={style.blue}
            Wrapper={'button'}
            type={'submit'}
            position={'right'}
            classNames={style.buttonForm}
        />
    );
};

export default defineBlock({
    Block: Submit,
    smartProps: {
        text: smartProps.string.withDefault('ENVOYER'),
    },
    setup: {
        title: 'Submit',
        parent: ['smartfire/contact---form---form-content', 'smartfire/contact---form---form-content---two-columns'],
    },
});
